import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {
	CardComponent,
	DatalayerService,
	MaybeExternalLinkDirective,
	PaddingSize,
	PromoImpressionArgs,
	SvgIconComponent,
	TrackImpressionDirective
} from '@woolworthsnz/styleguide';
import { NgIf } from '@angular/common';


@Component({
	selector: 'dc-article',
	templateUrl: './article.component.html',
	styleUrls: ['./article.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CardComponent, TrackImpressionDirective, MaybeExternalLinkDirective, NgIf, SvgIconComponent]
})
export class ArticleComponent implements OnInit {
	@Input() link: string;
	@Input() image: string;
	@Input() imageAlt: string;
	@Input() title: string;
	@Input() text: string;
	@Input() type?: string;
	@Input() target?: '_self' | '_blank' = '_self';
	@Input() trackClicks?= true;

	/**
	 * The dynamic content id used for analytics data
	 */
	@Input() id?: string;

	/**
	 * The dynamic content name used for analytics data
	 */
	@Input() name?: string;

	// If this article tile is hosted inside a carousel we use these properties for tracking data
	@Input() carouselName?: string | null;
	@Input() position?: number;

	padding = PaddingSize.None;

	// Analytics data for this component
	analyticsData: PromoImpressionArgs;

	constructor(private datalayerService: DatalayerService) { }

	public ngOnInit(): void {
		this.analyticsData = {
			id: this.id || '',
			name: this.name || this.title,
			creative: 'Article',
			imagePath: this.image,
			carouselName: this.carouselName,
			position: this.position,
			link: this.link,
		};
	}

	public trackClick(): void {
		if (!this.trackClicks) {
			return;
		}
		this.datalayerService.trackPromoClick(this.analyticsData);
	}
}
